<template>
  <div class="mypage-favorite-team-link-section">
    <h3 class="mypage-favorite-team-link-section__title">
      {{ $t('MypagePage.MypageTopPage.favoriteTeam') }}
    </h3>

    <div class="mypage-favorite-team-link-section__content">
      <div class="mypage-favorite-team-link-section__selected">
        <team-card-parts :name="name" :img="img" />
      </div>

      <atom-router-button
        v-if="enabledSelect"
        class="mypage-favorite-team-link-section__link"
        :to="'/mypage/favorite-team'"
        :linkText="$t('MypagePage.MypageTopPage.favoriteTeamChange')"
        colorType="tertiary"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import TeamCardParts from '@/components/common/card/TeamCardParts.vue'
import AtomRouterButton from '@/components/atoms/AtomRouterButton.vue'

/**
 * マイページ: トップ お気に入りチーム セクション
 * todo: チームデータ受渡
 */
export default defineComponent({
  name: 'MypageFavoriteTeamLinkSection',
  components: {
    TeamCardParts,
    AtomRouterButton,
  },
  props: {
    /**
     * お気に入りチーム名
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * お気に入りチーム画像
     */
    img: {
      type: String,
    },
    /**
     * 選択変更有効化
     */
    enabledSelect: {
      type: Boolean,
      default: true,
    },
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.mypage-favorite-team-link-section {
  width: 100%;
  margin-bottom: 24px;

  &__title {
    padding: 0 16px;
    margin-bottom: 8px;
    text-align: left;
    @include fontSetTextSmall(12);

    line-height: 1.67;
    color: $gray50;
  }

  &__content {
    background: $white;
  }

  &__selected {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 12px 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  &__link {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0;
    color: $black80;
  }
}

@media screen and (min-width: $responsiveMypageMaxWidth) {
  .mypage-favorite-team-link-section__content {
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }
}
</style>
